export const DELIVERY_DAYS = [
    { label: 'Lundi', name: 'monday' },
    { label: 'Mardi', name: 'tuesday' },
    { label: 'Mercredi', name: 'wednesday' },
    { label: 'Jeudi', name: 'thursday' },
    { label: 'Vendredi', name: 'friday' },
    { label: 'Samedi', name: 'saturday' },
];
